import React from 'react';
import VideoSlide from '../../body/VideoSlide';

export default function CoreCompoenents() {
  return <VideoSlide vidSrc={1198772465} />;
}
